import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { colors } from "../constants";

import { BACKEND_URL } from "@/lib/api";

// FAQ Accordion Component
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/faqs`);
        if (res.ok) {
          const data = await res.json();
          if (data.faqs && data.faqs.length > 0) {
            setFaqs(data.faqs);
          } else {
            // Fallback defaults
            setFaqs([
              {
                q: "How do I play HPL?",
                a: "Select a match, predict the total runs before the match starts, and lock your prediction.",
              },
              {
                q: "When can I make a prediction?",
                a: "Predictions close when the match begins. You can change your prediction at any time before the match starts.",
              },
              {
                q: "How do I win rewards?",
                a: "Rewards are based on how close your prediction is to the final total runs scored.",
              },
              {
                q: "Do I need to pay to play HPL?",
                a: "No, HPL is free to play for all Hudle users.",
              },
            ]);
          }
        }
      } catch (_error) {
        // silently ignore — FAQ has hardcoded fallback
      }
    };
    fetchFaqs();
  }, []);

  return (
    <div className="mt-8">
      <h3 className="text-sm font-semibold text-white/70 mb-5 uppercase tracking-wide">FAQs</h3>
      <div className="flex flex-col" style={{ gap: "14px" }}>
        {faqs.map((faq, i) => (
          <div
            key={i}
            className="rounded-xl overflow-hidden"
            style={{
              background: colors.cardBg,
              border: `1px solid ${colors.cardBorder}`,
            }}
          >
            <button
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-center justify-between p-4 text-left"
            >
              <span className="text-sm font-medium text-white/80">{faq.q}</span>
              <ChevronDown
                className={`w-4 h-4 text-white/40 transition-transform ${openIndex === i ? "rotate-180" : ""}`}
              />
            </button>
            <AnimatePresence>
              {openIndex === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className="overflow-hidden"
                >
                  <p className="px-4 pb-4 text-sm text-white/50">{faq.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

// About Section Component
const AboutSection = () => (
  <div id="faq-section" className="mt-10 pt-8 border-t border-white/10">
    <h3 className="text-lg font-semibold text-white mb-3">What is Hudle Premier League (HPL)?</h3>
    <p className="text-sm leading-relaxed" style={{ color: colors.textSecondary }}>
      Hudle Premier League (HPL) is a cricket prediction game where you guess the total runs scored
      by both teams in a match. Make accurate predictions, win Hudle credits, and stand a chance to
      win rewards worth up to 50 lakhs during the season.
    </p>
    <FAQSection />
  </div>
);

export default AboutSection;
